import ImgSideBar from '~/assets/images/sidebar/sidebarBg.svg';
import { IS_HOA_DEMO_MODE } from '~/utils/hoaDemoMode';
import { BaseMenu } from './BaseMenu';

const HOA_THEME = {
  containerStyle: { background: '#0B3B2E' },
  activeColor: '#1F8A6A',
  selectedColor: '#1F8A6A',
  panelColor: '#0F4D3B',
  tooltipBgColor: '#1F8A6A',
  linkTooltipBgColor: '#1F8A6A',
};

const DEFAULT_THEME = {
  containerStyle: { background: '#160D28' },
  activeColor: '#7717DD',
  selectedColor: '#7717DD',
  panelColor: '#2B0A53',
  tooltipBgColor: '#7717DD',
  linkTooltipBgColor: '#7717DD',
};

export const Menu = () => {
  const theme = IS_HOA_DEMO_MODE ? HOA_THEME : DEFAULT_THEME;
  return (
    <BaseMenu
      config={{
        ...theme,
        decoration: <img class="absolute bottom-0 left-0 w-full" src={ImgSideBar} alt="sidebar background" />,
      }}
    />
  );
};
